<template>
  <span
    class="flex w-7.5 items-center justify-center overflow-hidden rounded-[2px] p-0.5
           shadow-[2px_2px_7px_var(--shadow-color)]"
    :class="{ 'tag-tint': tag }"
    :style="tag && { '--tag-color': `#${tag.color}` }"
  >
    <span
      class="flex items-center"
      v-if="tag"
      :class="big
        ? 'box-border h-4 w-auto max-w-6.5 overflow-x-clip text-[0.875rem] leading-[0.875rem]'
        : 'h-2.5 w-5'"
    >
      {{ big ? tag.name : ''}}
    </span>
    <i v-else
      :class="big && 'text-[1.25rem]'"
      class="tr tr-notags flex items-center"
    ></i>
  </span>
</template>
<script setup>
defineProps({
  tag: {
    type: [Object, null],
  },
  big: {
    type: Boolean,
    default: false,
  },
});
</script>
